import React from 'react'
import { Button, Space } from 'antd';
import { RefSetCurrentPage } from '../hooks/NavigationHooks.js';
import * as locCon from "../LocalConstants.js"
import Title from 'antd/es/typography/Title';
import { RefContextLanguage } from '../providers/LanguageProvider.js';

function DashboardExhibitionSelect() {

  // Current Page
  const setCurrentPage = RefSetCurrentPage()

  const i18n = RefContextLanguage()



  return (
    <div className="App">
      <header className="App-header">
        <Space direction="vertical">
          <Title level={2}>{i18n.t('exhibitions')}</Title>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_EXHIBITION_FLIPPING_CARDS)}>{i18n.t('flippingCards')}</Button>
        </Space>

      </header>
    </div>
  )
}

export default DashboardExhibitionSelect